import React, { useEffect, useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import Dropdown from "./Dropdown";
import toast from "react-hot-toast";
import { validateProductPrice } from "@/utils/product";

const ConfigueOptions = ({
  product,
  setSku,
  setPrice,
  setProductOptions,
  t,
}) => {
  const [toggle, setToggle] = useState(false);

  const sizePlaceholder = t("Select size");
  const [sizeOption, setSizeOption] = useState(sizePlaceholder);
  const [colorOption, setColorOption] = useState(null);

  useEffect(() => {
    if (colorOption?.option_id && sizeOption?.option_id) {
      const findUserOption = product?._configurables?.find(
        (opt) =>
          opt?.options?.color === colorOption?.option_id &&
          opt?.options?.size === sizeOption?.option_id
      );
      console.log(
        "====================================| selected option |====================================",
        findUserOption
      );
      if (findUserOption) {
        setSku(findUserOption?.sku);
        setPrice(validateProductPrice(findUserOption?.prices_with_tax));
        setProductOptions({
          extension_attributes: {
            configurable_item_options: [
              {
                option_id: colorOption?.option_id,
                option_value: colorOption?.option_id,
              },
              {
                option_id: sizeOption?.option_id,
                option_value: sizeOption?.option_id,
              },
            ],
          },
        });
      } else {
        setColorOption(null);
        setSizeOption(sizePlaceholder);
        toast.error("Selected Option not available");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sizeOption, colorOption]);
  console.log(product?._configurables);
  console.log({ sizeOption, colorOption });
  return (
    <div className="max-[570px]:mb-3 max-[570px]:mx-0 max-[570px]:w-[150px]">
      {Object.entries(product?.option_details || {})?.length
        ? Object.entries(product?.option_details)?.map(
            ([optionTitle, optionValues]) =>
              optionValues?.length !== 0 ? (
                <>
                  {optionTitle === "color" ? (
                    <>
                      <label className="block mb-1 font-semibold text-zinc-400">
                        {t("Colors")}
                      </label>
                      <div className="border rounded-full flex items-center gap-3 py-2 px-3 -mx-2 w-[160px]">
                        {optionValues?.map((option, idx) => (
                          <div key={idx}>
                            <button
                              disabled={option?.option_id === colorOption}
                              style={{ backgroundColor: option?.value }}
                              onClick={() => {
                                setColorOption(option);
                                // setSizeOption(sizePlaceholder);
                                setProductOptions(null);
                              }}
                              className="relative flex items-center rounded-full cursor-pointer h-7 w-7 hover:opacity-90"
                            >
                              {option?.option_id === colorOption?.option_id ? (
                                <AiOutlineCheck className="absolute text-white -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" />
                              ) : null}
                            </button>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : optionTitle === "size" ? (
                    <>
                      <div className="max-[570px]:mb-3 max-[570px]:mx-0 max-[570px]:w-[150px]">
                        <label className="block mt-4 mb-2 font-semibold text-zinc-400">
                          {t("Sizes")}
                        </label>
                      </div>
                      <Dropdown
                        {...{
                          toggle,
                          setToggle,
                          option: sizeOption.lable,
                          optionPlaceholder: sizePlaceholder,
                          t,
                        }}
                      >
                        {optionValues?.map((option, idx) => (
                          <li
                            onClick={() => {
                              setSizeOption(option);
                              setToggle(false);
                            }}
                            key={idx}
                            className="px-4 py-2 cursor-pointer hover:text-slate-500 hover:bg-slate-100"
                          >
                            {option?.lable}
                          </li>
                        ))}
                      </Dropdown>
                    </>
                  ) : null}
                </>
              ) : null
          )
        : null}
    </div>
  );
};

export default ConfigueOptions;
